
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default BaseCmsBlock.extend({
  name: "BenefitsWorkingWithUsNewBlock",

  data: function () {
    return {
      swiperOptions: {
        spaceBetween: 10,
        slidesPerView: 1.1,
        slidesPerGroup: 1,

        breakpoints: {
          760: {
            spaceBetween: 20,
            slidesPerView: 2.4,
            slidesPerGroup: 2,
          },
          640: {
            slidesPerView: 1.9,
            slidesPerGroup: 1,
          },
          520: {
            slidesPerView: 1.8,
            slidesPerGroup: 1,
          },
          480: {
            slidesPerView: 1.5,
            slidesPerGroup: 1,
          },
        },
      }
    }
  },

  components: {
    Swiper,
    SwiperSlide
  },

  methods: {
    prevSlide: function () {},
    nextSlide: function () {},
  }
})
